import React from 'react';
import cx from 'classnames';

import styles from './styles.module.scss';
import {useTheme} from "@mui/material";
import flags from "~assets/footer/flags.png";
import logo from "~assets/footer/logo BBDD.png";
import basilea from "~assets/footer/CDB.png";

function Footer({ className }) {
  return (
    <div className={cx(styles.footer, className)}>
        <div >
            <div className={styles.copyright}>
              <a href="https://observatorio-infraestructura-as.org/">
                <img src={logo}/>
              </a>
              <div className={styles.verticalSeparator}></div>
              <a href="https://consensodebrasilia.org/">
                <img src={basilea}/>
              </a>
            </div>
            <div className={styles.logoContainer}>
                <img src={flags}/>
            </div>
        </div>
    </div>
  );
}

export default Footer;